import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'

import { AppState } from '../../../data/state'

interface IncludeBreakfastSummaryProps {
  includeBreakfast: boolean
}

const IncludeBreakfastSummary: React.FC<IncludeBreakfastSummaryProps> = ({
  includeBreakfast,
}) => {
  return (
    <>
      {includeBreakfast ? (
        <ListItem>
          <DisplayContent addNode contentKey="include-breakfast-summary">
            Breakfast
          </DisplayContent>
        </ListItem>
      ) : null}
    </>
  )
}

export default connect((state: AppState) => ({
  includeBreakfast: state.funnelOrder.includeBreakfast,
}))(IncludeBreakfastSummary)
